/**
 * A product or service of the tax payer, as the panel sees it.
 *
 * Called "Productos y servicios" in the interface and `CatalogItem` in the
 * code, because a good share of the tax payers invoice services and fees: the
 * SIFEN field is `dDesProSer`, description of the product and/or service.
 *
 * A default unit price is optional and belongs to a currency. Each invoice
 * line may still use a different price.
 */
interface CatalogItem {
  id?: number;
  taxPayerId?: number;
  description?: string;
  code?: string | null;
  measureUnit?: number | null;
  ivaType?: string | null;
  unitPrice?: number | null;
  priceCurrency?: string | null;
  isActive?: boolean;
  /** Only on creation: how many already issued lines the entry just claimed. */
  linkedItems?: number;
}

/**
 * A description invoiced repeatedly with no entry yet, as offered after saving
 * an invoice, with the count that justifies it.
 */
export interface CatalogSuggestion {
  description: string;
  normalizedDescription: string;
  code: string | null;
  measureUnit: number | null;
  ivaType: string | null;
  items: number;
  /** Whether that code points at this description and no other. */
  codeIdentifiesArticle: boolean;
}

/** What the tax payer has been charging for a line, to warn before saving. */
export interface PriceReference {
  matchedBy: "description" | "code" | null;
  median: number | null;
  prices: number[];
  sampleSize: number;
  outOfRange: boolean;
}

/**
 * Unit, the unit of measure every new line and entry starts at.
 *
 * What the item forms have always sent and what almost every line uses. The
 * invoice form and the catalogue let it be changed (see models/measure-unit.ts).
 */
export const MEASURE_UNIT_UNIT = 77;

export const newCatalogItem = (taxPayerId?: number): CatalogItem => {
  return {
    taxPayerId: taxPayerId,
    description: "",
    code: "",
    measureUnit: MEASURE_UNIT_UNIT,
    isActive: true,
  };
};

export default CatalogItem;
